<template>
  <footer class="footer">
    avec
    <a
      href="https://maprochaineauto.com"
      title="maprochaineauto"
      target="_blank">
      <img
        :src="logoMaprochaineauto"
        alt="logo"
        height="16">
    </a>
  </footer>
</template>

<script>
import logoMaprochaineauto from "@/assets/logo-maprochaineauto.png"

export default {
  name: "Footer",
  data() {
    return { logoMaprochaineauto }
  },
}
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
  bottom: 0;
  border-top: 1px solid color(gray05);
  z-index: 1;

  a {
    display: flex;
  }
}
</style>
